import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export const authentication = {
  namespaced: true,
  state: {
    user: {
      isAcceptTerms: null,
      message: ''
    },
    config: {
      ID_PORTAL: null
    },
    guid: '',
    showCaptcha: false
  },
  getters,
  mutations,
  actions
};
